import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCDocumentos } from "../../infrastructure/services/api/SVCDocumentos";
import IViewDocumentos from "../../presentation/view-interfaces/IViewDocumentos";

export const ObtieneListadoDocumentos = (selListaArancel: any, headers: any, codigoCarrera: string, codigoNegocio: number, rut: number, sistema: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let result: Array<IViewDocumentos> = [];
    SVCDocumentos.ObtieneListadoDocumentos(headers, codigoCarrera, codigoNegocio, rut, sistema, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selListaArancel(false, '', data);
        } else {
            selListaArancel(true, res.errorDetails, result);
        }
    });
};
export const InsertarDocumentos = (selInsertarDocumentos: any, tipo: number, rut: number, codigoCarrera: string, sistema: string, idDocumento: number, extension: string, base64: string, anio: number, periodo: number, codNegocio: number, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let result: Array<IViewDocumentos> = [];
    SVCDocumentos.InsertarDocumentos(tipo, rut, codigoCarrera, sistema, idDocumento, extension, base64, anio, periodo, codNegocio, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: IViewDocumentos = res.result;

            selInsertarDocumentos(false, '', data);
        } else {
            selInsertarDocumentos(true, res.errorDetails, result);
        }
    });
};
export const EliminarDocumentos = (selEliminarDocumentos: any,/*  tipo: number, */ rut: number, codigoCarrera: string, /* sistema: string, */ idDocumento: number, anio: number, periodo: number/* , extension: string, base64: string, anio: number, periodo: number */) => {
    let result: Array<IViewDocumentos> = [];
    SVCDocumentos.EliminarDocumentos(/* tipo, */ rut, codigoCarrera, /* sistema, */ idDocumento, anio, periodo/* , extension, base64, anio, periodo */).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: IViewDocumentos = res.result;

            selEliminarDocumentos(false, '', data);
        } else {
            selEliminarDocumentos(true, res.errorDetails, result);
        }
    });
};

